"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = ({ gridView, direction }) => {
    const theme = (0, material_1.useTheme)();
    const isBigScreen = (0, material_1.useMediaQuery)('(min-width:800px)');
    const containerStyle = Object.assign(Object.assign({ display: 'flex', background: theme.qlub.palette.white.main }, (gridView && {
        flexDirection: 'column',
        overflow: 'hidden',
    })), { alignItems: 'center' });
    const imageContainerStyle = {
        position: 'relative',
        width: gridView ? '100%' : '6.25rem',
        flexShrink: 0,
    };
    const contentContainerStyle = {
        width: gridView ? '100%' : 'auto',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        gap: '4px',
        padding: gridView ? '2px' : '0',
        paddingTop: gridView ? '10px' : '0',
    };
    const subContainer = {
        display: 'flex',
        width: '100%',
    };
    const gridViewSubContainer = {
        gap: 0,
    };
    const cellStyle = {
        display: 'flex',
        flexDirection: gridView ? 'column' : direction,
        alignItems: 'center',
        gap: gridView ? '0px' : '16px',
        width: '100%',
        minWidth: isBigScreen ? '160px' : '30vw',
    };
    const mediaStyles = {
        width: '100%',
        height: '100%',
        borderRadius: '8px',
        objectFit: 'cover',
        marginBlock: gridView ? 0 : '0.25rem',
        aspectRatio: '1',
    };
    const titleStyle = Object.assign(Object.assign({}, theme.qlub.typography.title_md), { color: theme.qlub.palette.onSurfaceColors.highEmphasis, fontSize: '14px', lineHeight: '22.40px' });
    const subTitleStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.onSurfaceColors.disabled, display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2, overflow: 'hidden' });
    const descriptionStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.onSurfaceColors.highEmphasis, display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2, overflow: 'hidden' });
    const priceStyle = Object.assign(Object.assign({}, theme.qlub.typography.title_md), { color: theme.qlub.palette.onSurfaceColors.highEmphasis, marginTop: '8px', fontSize: '14px', lineHeight: '22.40px' });
    const badgeCellStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px',
    };
    const lineColumn = {
        width: '4px',
        backgroundColor: 'transparent',
    };
    const lineColumnSelected = {
        backgroundColor: theme.qlub.palette.iris.main,
    };
    const listViewContainerStyle = {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '16px',
        position: 'relative',
    };
    const listViewContentStyle = {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        alignItems: 'flex-start',
        'html[dir="rtl"] &': {
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
    };
    const specialOfferStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: 'purple', marginBottom: '4px' });
    const priceContainerStyle = {
        display: 'flex',
        alignItems: 'baseline',
        'html[dir="rtl"] &': {
            flexDirection: 'row-reverse',
            justifyContent: 'flex-end',
        },
    };
    const oldPriceStyle = Object.assign(Object.assign({}, theme.qlub.typography.body_sm), { color: theme.qlub.palette.onSurfaceColors.disabled, textDecoration: 'line-through', marginLeft: '8px', 'html[dir="rtl"] &': {
            marginLeft: 0,
            marginRight: '8px',
        } });
    const listViewImageContainerStyle = {
        position: 'relative',
        width: '100px',
        height: '100px',
    };
    const listViewNoImageContainerStyle = {
        position: 'absolute',
        width: '100px',
        height: '28px',
        bottom: '0',
        right: '0',
    };
    const listViewMediaStyles = {
        width: '100%',
        height: '100%',
        borderRadius: '8px',
        objectFit: 'cover',
        aspectRatio: '1',
    };
    const indicatorOverlayStyle = {
        position: 'absolute',
        bottom: '4px',
        insetInlineEnd: '4px',
        zIndex: 0,
    };
    const gridPadding = {
        padding: '0px',
    };
    const listPadding = {
        padding: '20px 16px',
    };
    const imageContainerParent = {
        padding: '0px',
        width: '100%',
        alignContent: 'flex-start',
    };
    return {
        containerStyle,
        cellStyle,
        imageContainerStyle,
        mediaStyles,
        indicatorOverlayStyle,
        contentContainerStyle,
        titleStyle,
        subTitleStyle,
        descriptionStyle,
        priceStyle,
        badgeCellStyle,
        lineColumn,
        lineColumnSelected,
        subContainer,
        gridViewSubContainer,
        listViewContainerStyle,
        listViewContentStyle,
        listViewImageContainerStyle,
        listViewNoImageContainerStyle,
        listViewMediaStyles,
        specialOfferStyle,
        priceContainerStyle,
        oldPriceStyle,
        gridPadding,
        listPadding,
        imageContainerParent,
    };
};
exports.default = useStyle;
